<template>
  <select class="form-control city-select" name="city_id">
    <option :value="city.id" v-if="city" selected="">{{ city.name }}</option>
  </select>
</template>

<script>
export default {
  props: {
    city: {
      type: Object,
      required: false,
      default: null
    }
  },
  mounted() {
    setTimeout(function () {
      $('.city-select').select2({
        language: 'cs',
        ajax: {
          url: '/api/select2/cities-autocomplete-ajax',
          dataType: 'json',
          delay: 250,
          processResults: function(data) {
            return {
              results: $.map(data, function(item) {
                return {
                  text: item.name,
                  id: item.id
                }
              })
            }
          },
          cache: true
        }
      })
    }, 500)

    // if (this.city) {
    //   console.log('this.city', this.city)
    //   const city = {
    //     id: this.city.id,
    //     text: this.city.name
    //   }
    //   $(".city-select").select2('data', city);
    // }
  }
}
</script>
